var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"show d_f",class:'show-'+_vm.size,attrs:{"to":_vm.to}},[_c('div',{staticClass:"d_f d_f_c jc_sb w_1"},[_c('img',{attrs:{"src":_vm.img,"alt":""}}),_c('p',[_vm._v(_vm._s(_vm.title))])])])}
var staticRenderFns = []

export { render, staticRenderFns }